import React from "react";
import ForgotPasswordForm from "./ForgotPasswordForm";
import SignUpBanner from "../login/SignUpBanner";
import AuthBanner from "../../reusable/AuthBanner";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class forgotPassword extends React.Component {
  render() {
    return (
      <div>
        <AuthBanner title="Get WiFi Anywhere! Anytime!" />
        <ForgotPasswordForm />
        <SignUpBanner />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(forgotPassword);



// WEBPACK FOOTER //
// ./src/pages/forgotPassword/index.js